import { useQuery } from "@tanstack/react-query";
import { tokenAxios } from "@/utils/axios";
import { OrderResponse } from "@/types/my-tasks";
import { OrderArgs } from "@/types/order-table";
import { useOrdersContext } from "@/contexts/orders-context";
import { useAppState } from "@/contexts/app-state";
import { useQueryKeys } from "./use-query-keys";
import { ROWS_PER_PAGE } from "@components/Paginator";
import { useLocation } from "react-router-dom";
import { buildApiUrl } from "@/utils/api";

const getOrders = async (params: OrderArgs) => {
  const { data } = await tokenAxios().post<OrderResponse>(buildApiUrl("orders"), {
    filters: params.filters,
  },
  {
    params: {
      user: params.user,
      pageNumber: params.pageNumber,
      pageSize: params.pageSize,
      practiceId: params.practiceId,
      departmentId: params.departmentId,
      bucketName: params.bucketName,
      sortBy: params.sortBy,
      sortOrder: params.sortOrder,
    }
  }
  );
  return data;
};

export const useOrders = ({
  user,
  filters,
  bucketName,
  sortBy,
  sortOrder,
}: Pick<
  OrderArgs,
  "user" | "filters" | "bucketName" | "sortBy" | "sortOrder"
>) => {
  const { pageNumber } = useOrdersContext();
  const { context } = useAppState();
  const getQueryKey = useQueryKeys("orders");
  const { pathname } = useLocation();
  /*
    // 8967 and 3089 are test data.
    // Let's remove it later.
  */
  const practiceId = context?.athena?.practiceId ?? "8967";
  const departmentId = context?.athena?.departmentId ?? "3089";

  return useQuery<OrderResponse, Error>({
    queryKey: getQueryKey({ user, filters, bucketName }),
    queryFn: () =>
      getOrders({
        user,
        filters,
        pageNumber,
          pageSize: pathname.includes("user-activity") ?  1000 : ROWS_PER_PAGE,
        practiceId,
        departmentId,
        bucketName,
        sortBy,
        sortOrder,
      }),
    enabled: !!user,
  });
};
